// removed by extract-text-webpack-plugin
module.exports = {"detail":"style__detail___3rXwpU","content":"style__content___3XVUpg","fileDetail":"style__fileDetail___3zSUBx","table":"style__table___3AX9OM"};